<template>
    <el-form :disabled="formDisabled" :model="mod.formData" ref="formRef" :size="mod.config && mod.config.size || 'small'"
        :label-width="(mod.config && mod.config.labelWidth || 110) + 'px'">
        <el-row :gutter="20">
            <el-col :span="12" v-show="item.showed == true" v-for="(item, j) of mod.formData && mod.formData.list" :key="j" style="min-height: 51px;">
                <el-form-item :label="item.label" :prop="'list.' + j + '.val'" :rules="[
                    {
                        required: item.required,
                        message: item.label + '不能为空',
                        trigger: ['blur', 'change']
                    }
                ]">
                    <el-input v-if="['input','textarea','text'].includes(item.type)" v-model.trim="item.val"
                        :disabled="item.options.disabled" placeholder="请输入" :maxlength="item.options.maxlength" @blur="setForm(item)" :type="item.type">
                    </el-input>
                    <el-select v-if="item.type === 'select'" :disabled="item.options.disabled" class="w100" filterable
                        :allow-create="item.options.allowCreate" v-model="item.val" placeholder="请选择"
                        @blur="setForm(item, mod.formData)" @change="setForm(item, mod.formData)">
                        <!-- 有URL，下拉框从接口取 -->
                        <el-option :label="item.options.url ? op[item.options.field] : op.label"
                            :value="item.options.url ? op[item.options.field] : op.code"
                            v-for="(op, i) of item.options.valueData" :key="i"></el-option>
                    </el-select>
                    <el-radio-group @change="setForm(item)" v-if="item.type === 'radio'" v-model="item.val">
                        <el-radio :disabled="item.options.disabled" :label="op.code"
                            v-for="(op, i) of item.options.valueData" :key="i">
                            {{ op.label }}
                        </el-radio>
                    </el-radio-group>
                    <el-checkbox-group @change="setForm(item)" v-if="item.type === 'checkbox'" v-model="item.val">
                        <el-checkbox :disabled="item.options.disabled" :label="op.code"
                            v-for="(op, i) of item.options.valueData" :key="i">
                            {{ op.label }}
                        </el-checkbox>
                    </el-checkbox-group>
                    <el-date-picker @change="setForm(item)" v-if="item.type === 'date'" type="date" placeholder="选择日期"
                        format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="item.val" style="width: 100%">
                    </el-date-picker>
                    <el-upload :data="dataSet" :headers="headerSet" :disabled="item.options.disabled" class="uploadBox" v-if="item.type === 'file'"
                        :action="upAddr" :show-file-list="false" :on-success="
                            (res) => {
                                uploadSuccess(res, item);
                            }
                        ">
                        <div class="uploadText" v-if="item.val && item.val[0]">
                            <a class="ellipsis"
                                @click.prevent="downloadFile(item.val[0].fileDownloadUrl, item.val[0].fileName)">
                                {{item.val[0].fileName}}
                            </a>
                            <i v-if="!item.options.disabled" class="el-icon-close" @click.stop="clearUp(item)"></i>
                        </div>
                        <img slot="trigger" src="@/assets/img/upload.png" />
                    </el-upload>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
</template>
  
<script>
import { downloadFile } from "@/utils";
export default {
    name: "formTemplate",
    props: {
        formDisabled: {
            type: Boolean,
            default: false
        },
        mod: {
            type: Object,
            default() {
                return {};
            }
        },
        orderId:[String]
    },
    watch:{
        'mod.formData.list':{
            handler(val){
                val.forEach(item=>{
                    if(item.type === 'select' && item.options.url){
                        let param = {};
                        if(item.options.params && item.options.params.length>0){
                            item.options.params.forEach(v=>{
                                if(v == 'orderId'){
                                    param[v] = this.orderId;
                                }
                            }) 
                        }
                        this.$http[item.options.type](item.options.url,item.options.type == 'get'?{params:param}:param).then(({ data }) => {
                            item.options.valueData = data.data;
                        })
                    }
                })
            },
            immediate:true
        }
    },
    computed: {
        upAddr() {
            return window.SITE_CONFIG.baseUrl + '/checkmall-file/api/file/upload';
        },
        headerSet() {
            return { 'X-Admin-Token': this.$cookie.get('X-Admin-Token') }
        },
        dataSet() {
            const id = this.mod.formData.id;//订单详情-样品详情会返回id
            return id ? { typePrn: id } : {}
        }
    },
    methods: {
        getFormData() {
            //提取表单数据
            let form = {};
            for (var keys in this.mod.formData) {
                let item = this.mod.formData.list.find(v=>v.field == keys);
                // 只保存显示字段，下拉框选中隐藏的项不传
                if (keys != 'list' && item && item.showed==true) form[keys] = this.mod.formData[keys];
            }
            return form;
        },
        setForm(item, parent) {
            this.$set(this.mod.formData, item.field, item.val);
            if(item.options && item.options.valueData && item.options.valueData.length){
                let rule = item.options.valueData.filter(v=>v.rule && v.rule.length>0);
                if(rule.length>0){
                    rule.forEach(v=>{
                        v.rule.forEach(r=>{
                            // 联动其他控件显隐
                            parent.list.find(p=>p.label == r.label).showed = v.code == item.val ? r.showed : true;
                        })
                    })
                }
            }
            if (item.options && item.options.url) {
                // 下拉框联动
                let selectOne = item.options.valueData.filter(v => v[item.options.field] == item.val);
                // 找到code相同进行联动
                let mod = parent.list.filter(v => v.options.code == item.options.code);
                mod.forEach(v => {
                    // 联动赋值
                    if(v.field != item.field){
                        parent[v.field] = selectOne.length > 0 && selectOne[0][v.options.field] || '';
                        v.val = parent[v.field];
                        this.$forceUpdate();
                        this.$set(this.mod.formData, v.field, v.val);
                    }
                });
            }
            if(item.field === "YWYQ.f43"){
                // 资质盖章
                if(item.val.includes("RZTZ_CATL") && !item.val.includes("RZTZ_CMA")){
                    let zzgz = item.val.push("RZTZ_CMA")
                    this.$set(this.mod.formData, item.field, zzgz);
                }
            }
        },
        uploadSuccess(response, item) {
            item.val = [response.data.storage];
            this.$forceUpdate();
            this.setForm(item);
        },
        downloadFile(url, fileName) {
            downloadFile(url, fileName);
        },
        clearUp(item) {
            if (item.options.disabled) return
            item.val = '';
            this.$forceUpdate();
            this.setForm(item);
        }
    }
};
</script>
  